import { JsonProperty } from '../../../models/utilities/json-property';
import { DriverStatus } from '../enums/driver-status';

export class DriverRead {

    public id                   : number = 0;

    public serviceCenterId      : string = '';    

    public samsaraId            : string = '';    

    public firstName            : string = '';

    public middleName           : string = '';

    public lastName             : string = '';

    public employeeId           : string = '';

    public defaultTruckId       : number|undefined = undefined;

    public cellPhone            : string = '';

    public alternatePhone       : string = '';

    public rowVersion           : string = '';    

    public status               : DriverStatus = DriverStatus.Inactive;
    
    public truckName            : string = '';

    public passportId           : string = '';

    public driversLicenseNumber : string = '';

    public driversLicenseState  : string = '';

    @JsonProperty({ toType: 'date' })
    public driversLicenseExpiry : Date|undefined = undefined;
    
    @JsonProperty({ toType: 'date' })
    public physicalDueDate      : Date|undefined = undefined;

    public fullName             : string = '';

}
